export default "__VITE_ASSET__clssAKUJ__"